import React from 'react';
import { Banner } from '@amount/frontend-components';
import { getQueryStringParams } from '../../../util';
import BannerTextWrapper from './BannerTextWrapper';

interface IWelcomeBackRefinanceBannerProps {
  canApplyForRefi: boolean;
}

export const WelcomeBackRefinanceBanner: React.FC<IWelcomeBackRefinanceBannerProps> = ({ canApplyForRefi }) => {
  if (!canApplyForRefi) {
    return null;
  }

  const qsParams = getQueryStringParams(window.location.search);
  if (qsParams['from_apply_redirect'] !== 'true') {
    return null;
  }

  const bannerText = AvantConfig.TenantConfig.welcomeBackRefinanceBanner?.message ||
    "Welcome Back! Looking to borrow more? As an existing customer, you may be eligible to Refinance Your Loan and access extra funds by clicking the 'Need more money?' button below.";

  return (
    <Banner bannerStyle='success'>
      <BannerTextWrapper>
        {bannerText}
      </BannerTextWrapper>
    </Banner>
  );
};
